import name from './name'

const selectSliceData = state => state[name]
const selectOnboardingProfile = state => selectSliceData(state).onboarding
const selectProfilePopoverOpen = state => selectSliceData(state).playlistPopperOpen
const selectMyLearningBadge = state => selectSliceData(state).myLearningBadge
const selectMyLearningFeedback = state => selectSliceData(state).myLearningFeedback

export { selectOnboardingProfile, selectProfilePopoverOpen, selectMyLearningBadge, selectMyLearningFeedback }
